import React from 'react';
import AboutManager from '../../components/admin/AboutManager';

const About: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-primary-900">About Page</h1>
        <p className="text-primary-600 mt-2">
          Manage the content displayed on the About page, including company description, values, process, and profile image.
        </p>
      </div>
      
      <AboutManager />
    </div>
  );
};

export default About; 